export default "__VITE_ASSET__BFeVj_W6__"